import { createFileRoute, Outlet, Navigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { Layout } from '@/components/Layout';
import { OnboardingGate } from '@/components/OnboardingGate';

export const Route = createFileRoute('/_authenticated')({
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  const { user, isAuthenticated, checkAuth, isInitializing } = useAuthStore();

  useEffect(() => {
    if (isInitializing) {
      checkAuth();
    }
  }, [checkAuth, isInitializing]);

  if (isInitializing) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/" />;
  }

  // Check if user is a developer
  if (user.role !== 'developer') {
    useAuthStore.getState().logout();
    return <Navigate to="/" />;
  }

  return (
    <Layout>
      <OnboardingGate />
      <Outlet />
    </Layout>
  );
}

